import React from 'react';
import PropTypes from 'prop-types';
import { RouteHandler } from 'react-router';
import NotificationSystem  from 'react-notification-system';
import {muiTheme}  from 'core/common/config/mui-theme';
import commonService from 'core/common/service/commonService';
import MainMenu from 'core/components/mainmenu/mainMenu';
import {errorToTeams} from 'core/common/utils/logging';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {observer} from "mobx-react";
import securityService from "core/security/securityService";
import UAParser from "ua-parser-js";

import 'core/components/application/application.less';


// detekce react modu
  try {
    React.createClass({} as any);
  } catch(e) {
    console.log('REACT IS RUNNING IN ' + ((e.message.indexOf('render') >= 0)?'DEV':'PROD') + ' MODE');
  }


interface ApplicationState {
  loading: boolean;
}

@observer
export default class Application extends React.Component<{}, ApplicationState> {

  static contextTypes = {
    router: PropTypes.func.isRequired
  };
  static childContextTypes = {
    muiTheme: PropTypes.object.isRequired
  };


  state = {
    loading: false
  };

  private _notificationSystemRef: any;


  getChildContext() {
    return {muiTheme: getMuiTheme(muiTheme)};
  }


  componentWillMount() {

     const parser: any = new UAParser();
     const userAgent = parser.getResult();

    let username = (securityService.currentUser) ? securityService.currentUser.username : null;

    window.onerror = (message, source, lineno, colno, error) => {
      let reason: string = (error && error.stack) ? error.stack.toString() : (message + "");
      commonService.notifyError(reason, 'Client Error');
      if (__ENVIRONMENT__ == 'prod') {
        return errorToTeams(reason, userAgent, username);
      }
      //console.log('%c onerror: reason = %s, message = %s, source = %s, lineno = %s, colno = %s, error = %O', 'background-color: red', reason, message, source, lineno, colno, error);
    };

    window.addEventListener("unhandledrejection", (event) => {
      let anyEvent = event as any;
      let reason = (anyEvent.detail && anyEvent.detail.reason) ? anyEvent.detail.reason : (  (anyEvent.reason) ? anyEvent.reason : event.toString() );
      if (reason) {
        if (reason.status === 400) return;
        let _r = (reason.stack) ? reason.stack : reason;
        commonService.notifyError(reason, 'Client Error');
        if (__ENVIRONMENT__ == 'prod') {
          return errorToTeams(_r, userAgent, username);
        }
      }
    });
  }

  componentDidMount() {
    commonService.notificationSystem = this._notificationSystemRef;
    commonService.router = this.context.router;
    commonService.emitter.on('LOADING', (isOn) => {
      let [loading] = isOn;
      console.log('LOADING listener: ', loading );
      if( this.state.loading ? !loading : loading ) {
        this.setState({loading});
      }

    });
  };


  componentWillUnmount() {
    commonService.emitter.removeAllListeners('LOADING');
    commonService.notificationSystem = null;
  }


  notificationSystemRefHandler = comp => this._notificationSystemRef = comp;


  render() {

    let devtools = null;
    if (__ENVIRONMENT__ == 'devXX') {
      const DevTools = require('mobx-react-devtools').default;
      devtools = <DevTools />;
    }

    console.log('render application');

    return (
        <div id="content">
          {
            (this.state.loading) ? (
              <div className="loading loading--overlay">
                <div className="loading__content loading__content--overlay">
                  <p className="sr-only">Loading the view...</p>
                  <i className="fa fa-4x fa-spinner fa-spin"/>
                </div>
              </div>
            ) : ''
          }

          <MainMenu currentUser={securityService.currentUser} currentTenant={securityService.currentTenant} availableTenants={securityService.availableTenants} restrictionData={securityService.restrictionData}/>
          <RouteHandler />
          <NotificationSystem ref={this.notificationSystemRefHandler as any} />
          {devtools}
        </div>
    )
  }


}



// WEBPACK FOOTER //
// ./src/core/components/application/application.tsx